import {isFilled} from '@prismicio/client'
import {PrismicRichText} from '@prismicio/react'
import type {HeroV3SlicePricing} from 'prismicio-types'
import type {FC} from 'react'
// eslint-disable-next-line boundaries/dependencies -- grandfathered cross-slice import, predates the slice-boundaries rule
import {RatingsSection} from 'slices/HeroV2/RatingsSection'
import {PricingCard} from 'slices/HeroV3/components/PricingCard'
// eslint-disable-next-line boundaries/dependencies -- grandfathered cross-slice import, predates the slice-boundaries rule
import {LogoBarV2} from 'slices/LogoBar/v2/LogoBarV2'
import type {Context} from 'src/common/types'

type HeroV3PricingProps = {
  slice: HeroV3SlicePricing & {
    slice_type: string
    variation: string
  }
  componentIndex: number
  context: Context
}

export const HeroV3Pricing: FC<HeroV3PricingProps> = ({slice, componentIndex, context}) => {
  const logos = slice.primary.logos.map((logo) => logo.logo)

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="bg-green-dark"
      data-nav-dark="true"
    >
      <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-10 px-5 pb-10 pt-[122px] md:px-10 md:pb-16 md:pt-[137px] lg:px-5 xl:px-0">
        {/* Content */}
        <div className="flex w-full flex-col items-center gap-6">
          {isFilled.group(slice.primary.ratings) && (
            <RatingsSection
              darkBackground
              ratings={slice.primary.ratings}
              type={slice.primary.ratings_type}
              centered
              version="v2"
            />
          )}
          <PrismicRichText
            field={slice.primary.heading}
            components={{
              heading1: ({children}) => (
                <h1 className="md:text-h1 text-center text-[32px] font-medium leading-[normal] text-moss-white max-md:tracking-[-.32px]">
                  {children}
                </h1>
              ),
              heading2: ({children}) => (
                <h1 className="md:text-h2 text-center text-[32px] font-medium leading-[normal] text-moss-white max-md:tracking-[-.32px]">
                  {children}
                </h1>
              ),
              em: () => <br className="md:hidden" />,
            }}
          />
          <p className="text-tg-body-l max-w-[588px] text-center text-moss-white/[70%]">{slice.primary.description}</p>
          <div className="flex w-full flex-col gap-6 pb-4 pt-10 md:flex-row">
            {slice.primary.products.map((product, index) => (
              <PricingCard
                key={`pricing-card-${index}`}
                product={product}
                index={index}
                context={context}
                componentIndex={componentIndex}
              />
            ))}
          </div>
          <LogoBarV2 titleRte={slice.primary.logobar_text} logos={logos} />
        </div>
      </div>
    </section>
  )
}
